import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { useTimer } from 'shared/hooks/use-timer'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import styles from './styles.module.scss'

interface Props {
  showButtonForPay?: boolean
  bookingExpire?: number
}

export const HeaderMyTicket = ({ showButtonForPay, bookingExpire }: Props) => {
  const { t } = useTranslation()

  const timer = useTimer(showButtonForPay ? bookingExpire || 0 : 0)

  const formattedTime = [timer.hours, timer.minutes, timer.seconds]
    .map((val) => String(val).padStart(2, '0'))
    .join(':')

  return (
    <HeaderGoBack
      title={t('your_ticket')}
      variant="grey"
      actionRight={
        showButtonForPay &&
        bookingExpire! > 0 && (
          <p className={clsx(styles.headerTime, 'regular-14')}>
            {formattedTime}
          </p>
        )
      }
      buttonWhite
    />
  )
}
